export enum ComponentDefinitionCategories {
    BasicComponents = 'basic-components',
    Elements = 'elements'
};
